export default __webpack_public_path__ + "static/media/Cerniera_SX.d0f5fefa.svg";